import type { Criteria } from "../../../../api/followup/Followup.typed";

/** Criterion with 2 options: OK / To rework */
export function isSingleChoiceCriterion(criteria: Criteria): boolean {
  return (
    criteria.options.length === 2 &&
    criteria.options.includes("OK") &&
    criteria.options.includes("A retravailler")
  );
}

/** Sort criteria: empty → orange → green (non-mutating) */
export function sortCriteria(criteria: Criteria[]): Criteria[] {
  return [...criteria].sort((a, b) => {
    const getPriority = (c: Criteria) => {
      const selectedOptions = c.status || [];
      if (isSingleChoiceCriterion(c)) {
        if (selectedOptions.length === 0) return 1;
        return selectedOptions.includes("OK") ? 3 : 2;
      }
      if (selectedOptions.length === 0) return 1;
      return selectedOptions.length === c.options.length ? 3 : 2;
    };
    return getPriority(a) - getPriority(b);
  });
}

/** Bar color from criterion status: none | orange | green */
export function getBarColor(criteria: Criteria): "none" | "orange" | "green" {
  const selectedOptions = criteria.status || [];
  if (isSingleChoiceCriterion(criteria)) {
    if (selectedOptions.length === 0) return "none";
    return selectedOptions.includes("OK") ? "green" : "orange";
  }
  if (selectedOptions.length === 0) return "none";
  return selectedOptions.length === criteria.options.length ? "green" : "orange";
}
